export default "__VITE_ASSET__cc5992d8__"